<div class="hmn-background__accent hmn-shared-vert-bar"></div>
